import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SvgIcoArrowRight from 'components/icon/icons/IcoArrowRight';

export type SecondaryMenuTriggerProps = {
  ButtonText: string;
  ButtonDesc?: string;
  handleClick: () => void;
};

export default function SecondaryMenuTrigger({ ButtonText, ButtonDesc, handleClick }: SecondaryMenuTriggerProps) {
  return (
    <Box display="flex" flexDirection="column" gap={1} alignItems="center" style={{ width: '100%' }}>
      <Button
        fullWidth
        variant="outlined"
        size="medium"
        onClick={handleClick}
        endIcon={<SvgIcoArrowRight style={{ fontSize: 'inherit' }} />}
      >
        {ButtonText}
      </Button>
      <Box color="text.secondary" component="p" fontSize="12px" lineHeight="166%" letterSpacing={0.4}>
        {ButtonDesc}
      </Box>
    </Box>
  );
}
